import { CollapsableFormZone } from 'components/Form/CollapsableFormZone/CollapsableFormZone';
import { ChipListInput } from 'components/Inputs/ChipListInput/ChipListInput';
import { NumericInput } from 'components/Inputs/NumericInput/NumericInput';

import { FormRowContainer } from '../SettingsForm.style';
import { isValidEmail, SettingsFormKeys } from '../settingsFormValues';
import {
  getListError,
  SettingsSectionProps,
  useSettingsFieldHelpers,
} from '../useSettingsFieldHelpers';

export const PaymentSettingsSection = ({
  formik,
  isReadOnly,
}: SettingsSectionProps): JSX.Element => {
  const { settingsFormIntl, getTextFieldProps, renderSwitch } = useSettingsFieldHelpers(
    formik,
    isReadOnly,
  );

  const reconciliationEmailsError = getListError(
    formik.errors[SettingsFormKeys.RECONCILIATION_EMAILS],
  );
  const isPaymentEnabled = formik.values[SettingsFormKeys.IS_PAYMENT_ENABLED];
  const isPaymentCutoffEnabled = formik.values[SettingsFormKeys.IS_PAYMENT_CUTOFF_ENABLED];

  return (
    <CollapsableFormZone title={settingsFormIntl('sections.payment-settings')}>
      <>
        {renderSwitch(SettingsFormKeys.IS_PAYMENT_ENABLED, 'is-payment-enabled')}
        {isPaymentEnabled && (
          <>
            <FormRowContainer>
              <NumericInput
                {...getTextFieldProps(
                  SettingsFormKeys.SURCHARGE_PERCENTAGE,
                  'surcharge-percentage',
                )}
                inputProps={{ min: 0, max: 100, step: 0.01 }}
                required
              />
            </FormRowContainer>
            {renderSwitch(SettingsFormKeys.IS_PAYMENT_CUTOFF_ENABLED, 'is-payment-cutoff-enabled')}
            {isPaymentCutoffEnabled && (
              <FormRowContainer>
                <NumericInput
                  {...getTextFieldProps(
                    SettingsFormKeys.MAX_ALLOWED_DAYS_TO_PAY,
                    'max-allowed-days-to-pay',
                  )}
                  inputProps={{ min: 0, step: 1 }}
                  required
                />
              </FormRowContainer>
            )}
            <FormRowContainer>
              <ChipListInput
                id={SettingsFormKeys.RECONCILIATION_EMAILS}
                label={settingsFormIntl('form.reconciliation-emails.label')}
                placeholder={settingsFormIntl('form.reconciliation-emails.placeholder')}
                values={formik.values[SettingsFormKeys.RECONCILIATION_EMAILS]}
                onChange={(emails) =>
                  formik.setFieldValue(SettingsFormKeys.RECONCILIATION_EMAILS, emails)
                }
                isValidEntry={isValidEmail}
                invalidEntryMessage={settingsFormIntl('form.invalid-field')}
                error={Boolean(reconciliationEmailsError)}
                helperText={reconciliationEmailsError}
                disabled={isReadOnly}
              />
            </FormRowContainer>
          </>
        )}
      </>
    </CollapsableFormZone>
  );
};
